var _excluded = ["id", "type", "iconType", "name", "value", "label", "description"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import isEqual from 'lodash/isEqual';
import { RECENT } from './autocomplete-types';
var maxRecentSearch = 3;
export default (function () {
  var storageName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'recent-searches';
  var saveRecentSearch = values => {
    if (typeof localStorage !== 'undefined') {
      var currentListArr = JSON.parse(localStorage.getItem(storageName) || '[]');
      var thisSearch = {
        label: "".concat(values[0].name).concat(values.length > 1 ? " + ".concat(values.length - 1, " other") : '').concat(values.length > 2 ? 's' : ''),
        value: [...values]
      };
      localStorage.setItem(storageName, JSON.stringify([thisSearch, ...currentListArr.filter(item => !isEqual(item.label, thisSearch.label))].slice(0, maxRecentSearch)));
    }
  };
  var getRecentSearches = () => {
    if (typeof localStorage !== 'undefined') {
      var list = JSON.parse(localStorage.getItem(storageName) || '[]');
      return (list || []).map(_ref => {
        var searchLabel = _ref.label,
          _ref$value = _ref.value,
          searchValues = _ref$value === void 0 ? [] : _ref$value;
        return {
          type: RECENT,
          label: searchLabel,
          value: searchValues.map(_ref2 => {
            var id = _ref2.id,
              type = _ref2.type,
              iconType = _ref2.iconType,
              name = _ref2.name,
              value = _ref2.value,
              label = _ref2.label,
              description = _ref2.description,
              rest = _objectWithoutProperties(_ref2, _excluded);
            return _objectSpread({
              id: id || value,
              type: type || iconType,
              name: name || label,
              description
            }, rest);
          })
        };
      });
    }
    return [];
  };
  return {
    saveRecentSearch,
    getRecentSearches
  };
});